'use strict';

var _extends = require('../../../../@babel/runtime/helpers/esm/extends.js');
var objectWithoutProperties = require('../../../../@babel/runtime/helpers/esm/objectWithoutProperties.js');
var React = require('react');
var PropTypes = require('prop-types');
var KeyboardArrowLeft = require('../internal/svg-icons/KeyboardArrowLeft.js');
var KeyboardArrowRight = require('../internal/svg-icons/KeyboardArrowRight.js');
var useTheme = require('../styles/useTheme.js');
var IconButton = require('../IconButton/IconButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return n;
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

/**
 * @ignore - internal component.
 */

var _ref = /*#__PURE__*/React__namespace.createElement(KeyboardArrowRight, null);

var _ref2 = /*#__PURE__*/React__namespace.createElement(KeyboardArrowLeft, null);

var _ref3 = /*#__PURE__*/React__namespace.createElement(KeyboardArrowLeft, null);

var _ref4 = /*#__PURE__*/React__namespace.createElement(KeyboardArrowRight, null);

var TablePaginationActions = React__namespace.forwardRef(function TablePaginationActions(props, ref) {
  var backIconButtonProps = props.backIconButtonProps,
      count = props.count,
      nextIconButtonProps = props.nextIconButtonProps,
      onChangePage = props.onChangePage,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      other = objectWithoutProperties(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage"]);

  var theme = useTheme();

  var handleBackButtonClick = function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  };

  var handleNextButtonClick = function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  };

  return /*#__PURE__*/React__namespace.createElement("div", _extends({
    ref: ref
  }, other), /*#__PURE__*/React__namespace.createElement(IconButton["default"], _extends({
    onClick: handleBackButtonClick,
    disabled: page === 0,
    color: "inherit"
  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), /*#__PURE__*/React__namespace.createElement(IconButton["default"], _extends({
    onClick: handleNextButtonClick,
    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
    color: "inherit"
  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
});
process.env.NODE_ENV !== "production" ? TablePaginationActions.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
   */
  backIconButtonProps: PropTypes__default["default"].object,

  /**
   * The total number of rows.
   */
  count: PropTypes__default["default"].number.isRequired,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes__default["default"].object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChangePage: PropTypes__default["default"].func.isRequired,

  /**
   * The zero-based index of the current page.
   */
  page: PropTypes__default["default"].number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes__default["default"].number.isRequired
} : void 0;
var TablePaginationActions$1 = TablePaginationActions;

module.exports = TablePaginationActions$1;
